<template>
  <v-alert
    v-if="banner"
    type="warning"
    variant="tonal"
    density="compact"
    class="mb-3 banner-wrap"
  >
    {{ $t("acceptance.car_body.parts_banner", banner) }}
  </v-alert>
</template>

<script>
import { getDossiersByCars } from "@/api/compliance";
import { bannerOf } from "@/components/Waste/carBodyRelease.mjs";

const OBJECT_ID = /^[0-9a-f]{24}$/i;

// Stage 6 slice 4: "Attenzione: la carcassa di questo veicolo è già stata rilasciata il …" on the
// part edit dialog of /insert-parts (Q4-3). Display only: it never blocks saving and adds nothing
// to the save path. Only with waste on; it reads the car's by-cars row, and a failed load shows
// nothing.
export default {
  name: "CarBodyReleasedBanner",
  props: {
    // The part's car id, or null
    carId: { type: String, default: null },
  },
  data: () => ({
    row: null,
  }),
  computed: {
    wasteEnabled() {
      return this.$store.getters.wasteEnabled === true;
    },
    banner() {
      return bannerOf({ wasteEnabled: this.wasteEnabled, row: this.row });
    },
  },
  watch: {
    // immediate: runs before created(), so loadSeq is set here, never reset in a hook.
    carId: {
      immediate: true,
      handler() {
        this.load();
      },
    },
  },
  methods: {
    async load() {
      // Only the latest load may set the row (not reactive on purpose).
      this.loadSeq = (this.loadSeq || 0) + 1;
      const seq = this.loadSeq;
      this.row = null;
      if (!this.wasteEnabled || !this.carId || !OBJECT_ID.test(this.carId)) {
        return;
      }
      try {
        const result = await getDossiersByCars([this.carId]);
        if (seq !== this.loadSeq) return;
        this.row = ((result && result.dossiers) || [])[0] || null;
      } catch (err) {
        // A failed load shows no banner: the banner is a reminder, never a gate.
        if (seq === this.loadSeq) this.row = null;
      }
    },
  },
};
</script>

<style scoped>
.banner-wrap {
  overflow-wrap: anywhere;
}
</style>
